import './style.less'
import React from "react";

const VuiContainer: React.FC<any> = ({children}) => {
    return (
        <div className="vui-container-wrapper">
            <div className="container">
                {children}
            </div>
        </div>
    )
}

export default VuiContainer
